var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoldPodiumWithNumber = function SvgGoldPodiumWithNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114,
    height: 112,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF3E",
    d: "M0 4a4 4 0 0 1 4-4h106a4 4 0 0 1 4 4v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#721A31",
    d: "M0 18h114v94H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m47.601 54.644 7.832-4.444h5.412v25.696h5.808V81H48.877v-5.104h6.556V55.92l-5.06 2.904z"
  })));
};
export default SvgGoldPodiumWithNumber;